import { h, Component } from 'preact';
import { joinClasses, accessNested } from 'utils/utils';
import Link from 'components/bolt/link/link';
import Store from 'store/store';
import s from 'components/bolt/button/NTLiveButton.sss';

export default class NTLiveButton extends Component {
	constructor(props) {
		super(props);

		this.state = {
			hovering: false,
			menuOpen: false,
			regionSelectorOpen: false
		};

		this.toggleHover = this.toggleHover.bind(this);
		this.checkTransition = this.checkTransition.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.menuOpen !== this.props.menuOpen) {
			this.setState({ menuOpen: this.props.menuOpen });
		}

		if (prevProps.regionSelectorOpen !== this.props.regionSelectorOpen) {
			this.setState({ regionSelectorOpen: this.props.regionSelectorOpen});
		}
	}

	toggleHover(hovering) {
		const isTouch = accessNested(this.props, 'client.isTouch');

		if (isTouch) return;

		this.setState({ hovering });
	}

	checkTransition(e) {
		const isTargetProperty = e.propertyName === 'opacity';
		const isTargetValue = getComputedStyle(e.target).opacity == 0;
		if (isTargetProperty && isTargetValue) {
			this.toggleHover(false);
		}
	}

	render({ data, extraClass, onClick, copy = { accessibilityCopy: {}, baseCopy: {}} }, { hovering, menuOpen, regionSelectorOpen }) {
		const { label, title, type, pageID, icon = {}, ariaLabel, target, href } = data;

		const showLine = type === 'underline' || type === 'menu' || type === 'top' || type === 'footer';
		const showLeftIcon = type === 'menu' || type === 'menuRegionSelector';
		const showRightIcon = type === 'regionSelector' || type === 'top';
		const autoTriggerAnimationEnd = type === 'underline';

		return (
			<Link
				class={joinClasses(
					s.button,
					s[type],
					extraClass,
					hovering && s.hovering,
					menuOpen ? s.menuOpen : s.menuClosed,
					regionSelectorOpen ? s.regionSelectorOpen : s.regionSelectorClosed
				)}
				role='button'
				rel='noopener'
				target={target && target}
				title={copy.accessibilityCopy[title] || title}
				ariaLabel={copy.accessibilityCopy[ariaLabel] || ariaLabel}
				onMouseEnter={this.toggleHover.bind(true, true)}
				onMouseLeave={!autoTriggerAnimationEnd && this.toggleHover.bind(true, false)}
				onClick={e => {
					if (onClick) onClick(e);
					if (pageID) Store.emit('CLOSE_AND_NAVIGATE', pageID, e);
				}}
				href={href}
			>
				{showLeftIcon && <img class={s.icon} src={icon.src} alt={copy.accessibilityCopy[icon.alt] || icon.alt} />}
				<span class={s.label}>
					{copy.baseCopy[label] || label}
					{showLine && <div class={s.line} onTransitionEnd={autoTriggerAnimationEnd && this.checkTransition} />}
				</span>
				{showRightIcon && <img class={joinClasses(s.icon, s.right)} src={icon.src} alt={copy.accessibilityCopy[icon.alt] || icon.alt} />}
			</Link>
		);
	}
}
